<template>
	<div>
		<v-container grid-list-md>
			<h1>{{ $t('setup.title') }}</h1>

			<div class="py-2">
				<v-layout row wrap>
					<v-flex xs12 sm6>
						<v-card>
							<v-toolbar dark>
								<v-toolbar-title>{{
									$t('setup.workstation.title')
								}}</v-toolbar-title>
							</v-toolbar>

							<v-list two-line subheader>
								<v-list-item
									v-for="item in workstation"
									:key="item.title"
								>
									<v-list-item-avatar>
										<v-icon :class="[item.background]">{{
											item.icon
										}}</v-icon>
									</v-list-item-avatar>

									<v-list-item-content>
										<v-list-item-title>{{
											$t(
												'setup.workstation.' +
													item.title
											)
										}}</v-list-item-title>
										<v-list-item-subtitle>{{
											item.subtitle
										}}</v-list-item-subtitle>
									</v-list-item-content>

									<v-list-item-action>
										<v-btn
											icon
											ripple
											:href="item.url"
											target="_blank"
										>
											<v-icon color="grey lighten-1"
												>info</v-icon
											>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list>
						</v-card>
					</v-flex>

					<v-flex xs12 sm6>
						<v-card>
							<v-toolbar dark>
								<v-toolbar-title>{{
									$t('setup.others.title')
								}}</v-toolbar-title>
							</v-toolbar>

							<v-list two-line subheader>
								<v-list-item
									v-for="item in items"
									:key="item.title"
								>
									<v-list-item-avatar>
										<v-icon :class="[item.background]">{{
											item.icon
										}}</v-icon>
									</v-list-item-avatar>

									<v-list-item-content>
										<v-list-item-title>{{
											$t('setup.others.' + item.title)
										}}</v-list-item-title>
										<v-list-item-subtitle>{{
											item.subtitle
										}}</v-list-item-subtitle>
									</v-list-item-content>

									<v-list-item-action>
										<v-btn
											icon
											ripple
											:href="item.url"
											target="_blank"
										>
											<v-icon color="grey lighten-1"
												>info</v-icon
											>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list>
						</v-card>
					</v-flex>
				</v-layout>
			</div>
		</v-container>
	</div>
</template>

<script>
export default {
	data() {
		return {
			items: [
				{
					icon: 'mic',
					background: 'grey lighten-1 white--text',
					title: 'mic',
					subtitle: 'Rode Procaster',
					url: 'http://www.rode.com/microphones/procaster'
				},
				{
					icon: 'fas fa-sliders-h',
					background: 'grey lighten-1 white--text',
					title: 'mixer',
					subtitle: 'Yamaha MG10XUF',
					url: 'http://www.yamaha.com.sg/eshop/en/yamaha/MG10XUF'
				},
				{
					icon: 'fas fa-headphones',
					background: 'grey lighten-1 white--text',
					title: 'headphones-1',
					subtitle: 'Sennheiser GSP 300',
					url: 'https://en-us.sennheiser.com/gaming-headset-gsp-300'
				},
				{
					icon: 'fas fa-headphones',
					background: 'grey lighten-1 white--text',
					title: 'headphones-2',
					subtitle: 'Audio Technica ATH-M50xBT',
					url: 'https://www.audio-technica.com/m50xbt/index.html'
				},
				{
					icon: 'fas fa-mouse-pointer',
					background: 'grey lighten-1 white--text',
					title: 'mouse',
					subtitle: 'Logitech MX Master 2S',
					url:
						'https://www.logitech.com/en-us/product/mx-master-2s-flow'
				},
				{
					icon: 'fas fa-keyboard',
					background: 'grey lighten-1 white--text',
					title: 'keyboard',
					subtitle: 'HyperX Alloy FPS',
					url:
						'https://www.hyperxgaming.com/us/keyboards/alloy-fps-mechanical-gaming-keyboard'
				},
				{
					icon: 'fas fa-desktop',
					background: 'grey lighten-1 white--text',
					title: 'display',
					subtitle: 'Samsung S27H850QFN',
					url:
						'https://www.samsung.com/us/business/products/computing/monitors/800-series/sh850-series-23-8-ls24h850qfnxza/'
				},
				{
					icon: 'fas fa-ethernet',
					background: 'grey lighten-1 white--text',
					title: 'router',
					subtitle: 'ASUS RT-AC88U',
					url: 'https://www.asus.com/us/Networking/RT-AC88U/'
				},
				{
					icon: 'fas fa-server',
					background: 'grey lighten-1 white--text',
					title: 'nas',
					subtitle: 'Synology DiskStation DS718+',
					url: 'https://www.synology.com/en-global/products/DS718+'
				}
			],
			workstation: [
				{
					icon: 'fas fa-microchip',
					background: 'grey lighten-1 white--text',
					title: 'cpu',
					subtitle: 'Intel Core I7-7700 3.6 GHz',
					url:
						'https://ark.intel.com/content/www/us/en/ark/products/97128/intel-core-i7-7700-processor-8m-cache-up-to-4-20-ghz.html'
				},
				{
					icon: 'far fa-snowflake',
					background: 'grey lighten-1 white--text',
					title: 'cooler',
					subtitle: 'COOLERMASTER HYPER 212 EVO',
					url:
						'https://www.coolermaster.com/catalog/coolers/cpu-air-coolers/hyper-212-evo/'
				},
				{
					icon: 'fas fa-stream',
					background: 'grey lighten-1 white--text',
					title: 'gpu',
					subtitle: 'ASUS ROG STRIX GeForce RTX 2070 O8G',
					url:
						'https://www.asus.com/Graphics-Cards/ROG-STRIX-RTX2070-O8G-GAMING/'
				},
				{
					icon: 'fas fa-memory',
					background: 'grey lighten-1 white--text',
					title: 'memory',
					subtitle: 'HyperX Fury 8GB x 2',
					url: 'https://www.hyperxgaming.com/us/memory/fury-ddr4'
				},
				{
					icon: 'fas fa-bolt',
					background: 'grey lighten-1 white--text',
					title: 'psu',
					subtitle: 'EVGA SuperNOVA 550 G3 80+ Gold',
					url:
						'https://eu.evga.com/products/product.aspx?pn=220-G3-0550-Y2'
				},
				{
					icon: 'fas fa-code-branch',
					background: 'grey lighten-1 white--text',
					title: 'motherboard',
					subtitle: 'ASUS ROG STRIX B250I',
					url:
						'https://www.asus.com/Motherboards/ROG-STRIX-B250I-GAMING/'
				},
				{
					icon: 'fas fa-hdd',
					background: 'grey lighten-1 white--text',
					title: 'ssd',
					subtitle: 'Samsung 970 EVO NVMe M.2 500GB',
					url:
						'https://www.samsung.com/hu/memory-storage/970-evo-nvme-m2-ssd/MZ-V7E500BW/'
				},
				{
					icon: 'fas fa-hdd',
					background: 'grey lighten-1 white--text',
					title: 'hdd',
					subtitle: '2TB',
					url: ''
				},
				{
					icon: 'fas fa-box',
					background: 'grey lighten-1 white--text',
					title: 'case',
					subtitle: 'NZXT H700 Matte Black',
					url: 'https://www.nzxt.com/products/h700-matte-black'
				}
			]
		};
	}
};
</script>
